import React from 'react'
import { useSelector } from 'react-redux'

// Luci d'ambiente
export default function Lights() {  
    const lunghezza = useSelector(state => state.uiMainMenu.lunghezza);
    const larghezza = useSelector(state => state.uiMainMenu.larghezza);

    return (
        <>           
            <ambientLight 
                intensity={1}               
                color={0xffffff}
            />  
            <pointLight 
                color={0xffeeff}
                intensity={1 * 100}
                distance={100}
                decay={2}
                position={[lunghezza/2 - 1, 8, 0]}
                castShadow={true}
            /> 
            <pointLight 
                color={0xffeeff}
                intensity={1 * 100}
                distance={100}
                decay={2}
                position={[-lunghezza/2 + 1, 8, 0]}
                castShadow={true}
            /> 
            <pointLight 
                color={0xffeeff}
                intensity={1 * 100}
                distance={100}
                decay={2}
                position={[0, 8, larghezza/2 - 1]}
                castShadow={true}
            /> 
            <pointLight 
                color={0xffeeff}
                intensity={1 * 100}
                distance={100}
                decay={2}
                position={[0, 8, -larghezza/2 + 1]}
                castShadow={true}
            />             
           <directionalLight position={[0, 8, 0]} 
                intensity={0.5} 
                castShadow={true}
                shadow-mapSize-width={1024}
                shadow-mapSize-height={1024}   
            >  
            <orthographicCamera attach="shadow-camera" args={[-25, 25, 25, -25, 0.1, 50]} />
            </directionalLight>            
            <hemisphereLight 
                color={0xddeeff}
                groundColor={0x0f0e0d}
                intensity={0.7}             
            />           
        </>
    )
}
